import { icons } from "assets/icons";
import { BullpointCircle } from "components/BullpointCircle";
import TextButton from "components/Button/TextButton";
import { Horizontal, Vertical } from "gls";
import React from "react";
import { SortableElement, SortableElementProps } from "react-sortable-hoc";
import { colours } from "styling/colours";
import { style } from "typestyle";

type OrderableListItemProps = SortableElementProps & {
  item: React.ReactNode;
  idx: number;
  nItems: number;
  canRearrange?: boolean;
  isMobileWidth?: boolean;
  onMoveUp?: (index: number) => void;
  onMoveDown?: (index: number) => void;
};

const OrderableListItem: React.ComponentClass<OrderableListItemProps, any> = SortableElement(
  ({
    item,
    idx,
    nItems,
    canRearrange,
    onMoveUp,
    onMoveDown,
    isMobileWidth,
  }: OrderableListItemProps) => (
    <Horizontal
      spacing={7}
      verticalAlign="center"
      className={style({
        cursor: canRearrange ? "grab" : undefined,
        position: "relative",
        marginBottom: isMobileWidth && idx < nItems ? "20px" : undefined,
      })}
    >
      {canRearrange && (
        <BullpointCircle
          value={idx}
          size={30}
          colour={colours.primaryText}
          background="#ecedef"
          className={
            isMobileWidth
              ? style({
                position: "absolute",
                left: 7,
                top: -37,
              })
              : undefined
          }
        />
      )}
      {item}
      {nItems > 1 && canRearrange && !isMobileWidth && (
        <Vertical spacing={5} horizontalAlign="center">
          <TextButton
            secondary
            className={style({ visibility: idx !== 1 ? "visible" : "hidden" })}
            onClick={() => onMoveUp?.(idx - 1)}
            title="Move Up"
          >▲</TextButton>
          <icons.ReOrderIcon aria-label="re-order items" fill="#808285" />
          <TextButton
            secondary
            className={style({ visibility: idx !== nItems ? "visible" : "hidden" })}
            onClick={() => onMoveDown?.(idx - 1)}
            title="Move Down"
          >
            ▼
          </TextButton>
        </Vertical>
      )}
    </Horizontal>
  )
);

export default OrderableListItem;
